
import { supabase } from "@/integrations/supabase/client";
import { User, UserRole } from "./types";

// Function to save packer relations to the database
export const savePackerRelations = async (medewerkerId: string, packers: string[], medewerkerNaam: string) => {
  try {
    console.log("Saving packer relations for medewerker:", medewerkerId, "name:", medewerkerNaam, "packers:", packers);
    
    // First, remove all existing relations for this medewerker
    const { error: deleteError } = await supabase
      .from('medewerker_inpakker_relations')
      .delete()
      .eq('medewerker_id', medewerkerId);
      
    if (deleteError) {
      console.error("Error removing existing packer relations:", deleteError);
      return;
    }
    
    // Don't proceed if there are no packers to add
    if (!packers.length) {
      console.log("No packers to add for this medewerker");
      return;
    }
    
    // Create relations data for batch insert
    const relationsToInsert = packers.map(packer => ({
      medewerker_id: medewerkerId,
      inpakker_naam: packer,
      medewerker_naam: medewerkerNaam // Add the medewerker name
    }));
    
    console.log("Inserting relations:", relationsToInsert);
    
    // Insert new relations
    const { data, error: insertError } = await supabase
      .from('medewerker_inpakker_relations')
      .insert(relationsToInsert)
      .select();
      
    if (insertError) {
      console.error("Error inserting packer relations:", insertError);
    } else {
      console.log("Successfully saved packer relations for medewerker:", medewerkerId, "Response:", data);
    }
  } catch (error) {
    console.error("Error in savePackerRelations:", error);
  }
};

// Function to record logout timestamp in the database
export const recordLogoutTimestamp = async (userId: string) => {
  try {
    console.log("Recording logout timestamp for user:", userId);
    
    const { error } = await supabase
      .from('medewerkers')
      .update({ 
        last_logout: new Date().toISOString() 
      })
      .eq('id', userId);
      
    if (error) {
      console.error("Error recording logout timestamp:", error);
    } else {
      console.log("Successfully recorded logout timestamp");
    }
  } catch (error) {
    console.error("Error in recordLogoutTimestamp:", error);
  }
};

// Helper function to determine role - uses explicit role field, falls back to functie for backwards compatibility
export const determineUserRole = (role: string | null, functie?: string | null): UserRole => {
  // Priority 1: Use explicit role field
  if (role) {
    const normalizedRole = role.toLowerCase();
    if (normalizedRole === 'management' || normalizedRole === 'admin') return "management";
    if (normalizedRole === 'planner') return "planner";
    if (normalizedRole === 'medewerker') return "medewerker";
  }
  
  // Priority 2: Fallback to functie text-matching (backwards compatibility)
  if (functie) {
    const normalizedFunctie = functie.toLowerCase();
    if (normalizedFunctie === 'management' || normalizedFunctie === 'admin') {
      return "management";
    } else if (normalizedFunctie === 'planner') {
      return "planner";
    }
  }
  
  return "medewerker";
};
